module.exports = __webpack_public_path__ + "img/HouseIconGrey.5b94f55b.svg";